import { render } from "./GerenciarUsuarios.vue?vue&type=template&id=16d024e4"
import script from "./GerenciarUsuarios.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__